import { useState, useEffect } from 'react'
import type { Dispatch, SetStateAction } from 'react'

import useCookie from '../useCookie'

export type usePersistedStateCookie = <T>(
  key: string,
  initialState: T
) => [T, Dispatch<SetStateAction<T>>]

const usePersistedStateCookie = <T>(key: string, initialState: T) => {
  const [cookieValue, updateCookie] = useCookie<T>(key, initialState)

  const [state, setState] = useState<T>((): T => cookieValue as T)

  useEffect(() => updateCookie(String(state)), [updateCookie, state])

  return [state, setState] as const
}

export default usePersistedStateCookie
